import React from "react";

const Dots = ({ color }) => {
  return (
    <div className={`background__dots ${color}`}>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
      <div className={`background__dots_dot ${color}`}></div>
    </div>
  );
};

export default Dots;
